import Api from '@api';

import common from './blocks/common'
import tag from './blocks/tag'

import { formConfig } from './config/formConfig'

export default {
  name: 'vmiTransferDetail',
  components: {
    common,
    tag
  },
  data() {
    const thead = formConfig(this).thead;
    return {
      commonData: {},
      thead
    };
  },
  computed:{
    injectData(){
      return this.$route.query || {}
    }
  },
  activated() {
    this.getData();
  },
  mounted() {
    this.init();
  },
  methods: {
    async init(){
      await this.getData()
    },
    async getData() {
      let { status, data } = await Api.GetVmiTransferByVmiId({
        VMI_ID: this.injectData.VMI_ID
      });
      if (Number(status) === 200) {

        let result = JSON.parse(JSON.stringify(data));
        this.$refs.common.$refs.common.formData = result;
        this.thead
          .filter(item => item !== "THead")
          .forEach(item => {
            this.$refs.tag.$refs[item][0].formData = result
          })
      }
    },
    handleConfirm() {
      this.$emit('close')
    },
    handleClose() {
      this.$emit('close')
    }
  }
}